export default {
    validate:{
        len_10:'长度在10以内',
        len_30:'长度在30以内',
        len_50:'长度在50以内',
        len_20:'长度在20以内',
        len_120:'长度在120以内',
        len_255: '长度在255以内',
        len_250: '长度在250以内',
        email_required: '邮箱不能为空',
        email_format:"请输入正确的邮箱地址",
        
        //客户
        customer_name_required: '企业名称不能为空',
        customer_code_required: '企业ID不能为空',
        customer_status_required: '企业状态不能为空',
        customer_contact_required: '联系人不能为空',
        customer_phone_required: '联系方式不能为空',
        customer_email_required: '邮箱不能为空',
        customer_email_format: '请输入正确的邮箱地址',
        customer_phone_format: '请输入正确的号码格式',

        //User
        user_name_required:"名称不能为空",
        user_account_required:"账号不能为空",
        user_role_required:"角色不能为空",
        user_mobile_required:"手机号码不能为空",
        user_company_required:"企业不能为空",
        user_role_type_required:"角色类型不能为空",
        user_archit_required:"客户使用类型下，关联架构不能为空",
        user_proxy_customer_required:"代理客户不能为空",
        user_operable_resource_required:"可操作资源不能为空",
    
        //参数
        param_name_required:"名称不能为空",
        param_code_required:"编码不能为空",
        param_content_required:"参数内容不能为空",
        
    }
}